// import ReportTimeReportsByUser_Legacy
//     from "../../../../../core/model2/report/reports/time-reports/_old_to_delete_by-user/time-reports-by-user"
import {generateUniqueId} from "../../../../../core/gd/utils/misc/generate-unique-id"
import {timeReportingConfig} from "../../../../../analytics/dashboard/time-reporting-config"
import ReportAttendance from "../../../../../core/model2/report/reports/hr/attendance/attendance-report"
import ReportClockIn from "../../../../../core/model2/report/reports/hr/clock-in-report/clock-in-report"
import ReportResourceAllocation
    from "../../../../../core/model2/report/reports/resource/resource-allocation/resource-allocation"
import ReportResourceAvailability
    from "../../../../../core/model2/report/reports/resource/resource-availability/resource-availability"
import ReportTaskBurnUp from "../../../../../core/model2/report/reports/task/burn-up/task-burn-up"
import ReportTaskBurnDown from "../../../../../core/model2/report/reports/task/burn-down/task-burn-down"
import ReportProgressReport from "../../../../../core/model2/report/reports/task/progress-report/progress-report"
import ReportTasksSummary from "../../../../../core/model2/report/reports/task/summary/summary"
import ReportTasksSummaryByUser from "../../../../../core/model2/report/reports/task/summary-by-user/summary-by-user"
import ReportProcessFlows from "../../../../../core/model2/report/reports/communication/process-flow/process-flows"
import ReportUsersCommunications
    from "../../../../../core/model2/report/reports/communication/users-communications/users-communications"
import ReportUsersCollaborations
    from "../../../../../core/model2/report/reports/communication/users-collaborations/users-collaboration"
import ReportEffortsDistributionByUser
    from "../../../../../core/model2/report/reports/time-reports/efforts-distribution/efforts-distribution-by-user/efforts-distribution-by-user"
import ReportEffortsDistributionByProject
    from "../../../../../core/model2/report/reports/time-reports/efforts-distribution/efforts-distribution-by-project/efforts-distribution-by-project"
import ReportSelfOrganization
    from "../../../../../core/model2/report/reports/behavior/self-organization/self-organization"
import ReportSelfPlanning from "../../../../../core/model2/report/reports/behavior/self-planning/self-planning"
import ReportAvgResponseTime
    from "../../../../../core/model2/report/reports/behavior/avg-response-time/avg-response-time"
import ReportVacationReport from "../../../../../core/model2/report/reports/hr/vacation-report/vaction-report"
import ReportProjectsVelocity from "../../../../../core/model2/report/reports/task/velocity/velocity"
import ReportDaily from "../../../../../core/model2/report/reports/hr/daily-report/daily-report"
import ReportTasksCategoryChart from "../../../../../core/model2/report/reports/task/tasks-category-chart/tasks-category-chart"
import ReportTasksTimeChart from "../../../../../core/model2/report/reports/task/tasks-time-chart/tasks-time-chart"

export enum TemplateGroups {
    FAVORITES               = 'favorites',
    TASKS_SUMMARY           = 'tasks-summary',
    AGILE                   = 'agile',
    RESOURCE_PLANNING       = 'resource-planning',
    TIME_REPORTING          = 'time-reporting',
    EFFORTS_DISTRIBUTION    = 'efforts-distribution',
    HR                      = 'hr',
    BEHAVIOR                = 'behavior',
    COLLABORATION_PROCESSES = "collaboration-processes"
}

export type ReportsSelectorGroup = {
    title    : string
    icon     : string
    value    : TemplateGroups
    items    : any[]
    grouped? : boolean
}

export default function modalReportSelect_getTemplates():ReportsSelectorGroup[] {


    const attendanceReport = new ReportAttendance({
        id      : generateUniqueId(),
        name    : 'Attendance Report',
    })

    const clockInReport = new ReportClockIn({
        id      : generateUniqueId(),
    })

    const clockEntriesReport = new ReportDaily({
        id      : generateUniqueId(),
    })

    const vacationReport = new ReportVacationReport({
        id      : generateUniqueId(),
        name    : 'Vacation Report',
    })

    const resourceAllocationReport = new ReportResourceAllocation({
        id      : generateUniqueId(),
        name    : 'Resource Allocation',
    })

    const resourceAvailabilityReport = new ReportResourceAvailability({
        id      : generateUniqueId(),
        name    : 'Resource Availability',
    })

    const taskBurnUp = new ReportTaskBurnUp({
        id      : generateUniqueId(),
        name    : 'Burnup',
    })

    const taskBurnDown = new ReportTaskBurnDown({
        id      : generateUniqueId(),
        name    : 'Burndown',
    })

    const projectsVelocity = new ReportProjectsVelocity({
        id      : generateUniqueId(),
        name    : 'Velocity',
    })

    const progressReport = new ReportProgressReport({
        id      : generateUniqueId(),
        name    : 'Progress report',
    })

    const tasksCategoryChart = new ReportTasksCategoryChart({
        id      : generateUniqueId(),
        name    : ReportTasksCategoryChart.reportName // 'Custom chart',
    })

    const tasksTimeChart = new ReportTasksTimeChart({
        id      : generateUniqueId(),
        name    : ReportTasksTimeChart.reportName // 'Custom chart',
    })

    const tasksSummaryByProject = new ReportTasksSummary({
        id      : generateUniqueId(),
        name    : 'Tasks summary by project',
    })

    const tasksSummaryByUser = new ReportTasksSummaryByUser({
        id      : generateUniqueId(),
        name    : 'Tasks summary by user',
    })

    const effortsDistributionByUser = new ReportEffortsDistributionByUser({
        id      : generateUniqueId(),
        name    : 'Efforts distribution by user',
    })

    const effortsDistributionByProject = new ReportEffortsDistributionByProject({
        id      : generateUniqueId(),
        name    : 'Efforts distribution by project',
    })

    const selfOrganization = new ReportSelfOrganization({
        id      : generateUniqueId(),
        name    : 'Self organization',
    })

    const selfPlanning = new ReportSelfPlanning({
        id      : generateUniqueId(),
        name    : 'Self planning',
    })

    const avgResponseTime = new ReportAvgResponseTime({
        id      : generateUniqueId(),
        name    : 'Avg. response time',
    })

    const processFlows = new ReportProcessFlows({
        id      : generateUniqueId(),
        name    : 'Process flows',
    })

    const usersCommunications = new ReportUsersCommunications({
        id      : generateUniqueId(),
        name    : 'Communication',
    })

    const usersCollaborations = new ReportUsersCollaborations({
        id      : generateUniqueId(),
        name    : 'Collaborations',
    })

    return [
        {
            title  : "Favorites",
            icon   : "i5-star-empty",
            value  : TemplateGroups.FAVORITES,
            grouped: true,
            items  : [
                {
                    title: "Tasks summary",
                    reports: [
                        tasksSummaryByProject,
                        tasksSummaryByUser
                    ]
                },
                {
                    title: "Agile",
                    reports: [
                        taskBurnUp,
                        taskBurnDown,
                    ]
                },
                {
                    title: "Resource Planning",
                    reports: [
                        resourceAllocationReport,
                        resourceAvailabilityReport
                    ]
                },
                {
                    title: "Time Reporting",
                    reports: [
                        timeReportingConfig[0],
                        timeReportingConfig[3],
                    ]
                },
                {
                    title: "Efforts Distribution",
                    reports: [
                        effortsDistributionByUser,
                        effortsDistributionByProject
                    ]
                },
                {
                    title: "HR",
                    reports: [
                        attendanceReport,
                        clockInReport,
                        clockEntriesReport
                    ]
                }
            ]
        },
        {
            title: "Tasks",
            icon : "i5-task",
            value: TemplateGroups.TASKS_SUMMARY,
            items: [

                tasksCategoryChart,
                tasksTimeChart,

                tasksSummaryByProject,
                tasksSummaryByUser,
                progressReport,
            ]
        },
        {
            title: "Time Reporting",
            icon : "i5-my-time",
            value: TemplateGroups.TIME_REPORTING,
            items: timeReportingConfig
        },
        {
            title: "Agile",
            icon : "i5-widget-report",
            value: TemplateGroups.AGILE,
            items: [
                taskBurnUp,
                taskBurnDown,
                projectsVelocity
            ]
        },
        {
            title: "Resource Planning",
            icon : "i5-timeline",
            value: TemplateGroups.RESOURCE_PLANNING,
            items: [
                resourceAllocationReport,
                resourceAvailabilityReport
            ]
        },
        {
            title: "Efforts Distribution",
            icon : "i5-pie-chart",
            value: TemplateGroups.EFFORTS_DISTRIBUTION,
            items: [
                effortsDistributionByUser,
                effortsDistributionByProject
            ]
        },
        {
            title: "HR",
            icon : "i5-attendance",
            value: TemplateGroups.HR,
            items: [
                attendanceReport,
                clockInReport,
                clockEntriesReport,
                vacationReport
            ]
        },
        {
            title: "Behavior",
            icon : "i5-tachometer",
            value: TemplateGroups.BEHAVIOR,
            items: [
                selfOrganization,
                selfPlanning,
                avgResponseTime
            ]
        },
        {
            title: "Collaboration",
            icon : "i5-users",
            value: TemplateGroups.COLLABORATION_PROCESSES,
            items: [
                processFlows,
                usersCollaborations,
                usersCommunications
            ]
        },
    ]
}
